var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"k-download"},[_c('a',{staticClass:"icon",attrs:{"download":"","href":_vm.urlToDonload(_vm.id),"target":"_blank"}},[_c('v-icon',{attrs:{"color":"grey darken-2","medium":""}},[_vm._v("cloud_download")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }